// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"419":"6237690f","476":"d0d8232b","787":"84b97b5a","858":"8a4448a3","942":"1f807fbe"}[chunkId] + ".chunk.js";
};